import React from "react";
import ModalWaringIcon from "../assets/icons/warning-green-icon.svg";
import Notice from "../views/Errors/Notice";
import EmailLink from "../views/Errors/EmailLink";

const TemporarilyDown = ({ onRefresh }) => {

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="temporarily-down-container ageo-regular">
      <div className="temporarily-down-card">
        <div className="icon-wrapper">
          <div className="icon-pulse"></div>
          <img 
            src={ModalWaringIcon} 
            alt="warning icon" 
            className="warning-icon"
          />
        </div>

        <Notice title="We’ll Be Back Soon">
          {/* <>
            <p className="error-message">
              We’re currently making some updates behind the scenes or fixing a temporary issue. Any interruptions during business hours are resolved quickly, and we’re working to get everything back up as soon as possible.
            </p>
            <p className="error-message">Thanks for your patience while we get things running smoothly again.</p>
            <p className="contact-message">
               Need help in the meantime? Contact us at <EmailLink className="email-link" />.
            </p>
          </> */}
        </Notice>

        {/* <div className="action-buttons">
          <button 
            onClick={handleRefresh} 
            className="btn btn-green btn-refresh"
          >
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M23 4v6h-6" />
              <path d="M1 20v-6h6" />
              <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10" />
              <path d="M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
            </svg>
             Try Again
          </button>
        </div> */}

        {/* <div className="eta-message mx-auto">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span>Status update: Our team is actively working on it.</span>
        </div> */}
      </div>
    </div>
  );
};

export default TemporarilyDown;